export const allMixin = {
	methods: {
		numberWithCommas(x) {
			if (x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
			} else {
				return 0
			}
		},
		formatDate(dateStr) {
			if (!dateStr) return '-' // biar aman kalau null/undefined/kosong
			const d = new Date(dateStr)
			const y = d.getUTCFullYear()
			const m = String(d.getUTCMonth() + 1).padStart(2, '0')
			const day = String(d.getUTCDate()).padStart(2, '0')
			const h = String(d.getUTCHours()).padStart(2, '0')
			const min = String(d.getUTCMinutes()).padStart(2, '0')
			return `${day}/${m}/${y} ${h}:${min} `
		},
		formatDateHour(dateStr) {
			if (!dateStr) return '-' // biar aman kalau null/undefined/kosong
			const d = new Date(dateStr)
			const y = d.getUTCFullYear()
			const m = String(d.getUTCMonth() + 1).padStart(2, '0')
			const day = String(d.getUTCDate()).padStart(2, '0')
			const h = String(d.getUTCHours()).padStart(2, '0')
			const min = String(d.getUTCMinutes()).padStart(2, '0')
			return `${day}/${m}/${y} ${h}:${min} `
		},
		displayValue(value) {
			if (value === null || value === 'null' || value === undefined || value === 'undefined' || value === '') {
				return '-'
			}
			return value
		},
		hitungUsia(tanggalLahir) {
			const today = new Date()
			const birthDate = new Date(tanggalLahir)
			let age = today.getFullYear() - birthDate.getFullYear()
			const m = today.getMonth() - birthDate.getMonth()

			// kalau bulan belum lewat, atau bulan sama tapi hari belum lewat → usia dikurangi 1
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--
			}

			return age
		},
		removeSession() {
			localStorage.removeItem('token')
			localStorage.removeItem('refreshToken')
			localStorage.removeItem('notif')
			localStorage.removeItem('user_login')
			localStorage.removeItem('user_detail')
			localStorage.removeItem('my_access')
		},
		randomString(length) {
			var result = ''
			var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			var charactersLength = characters.length
			for (var i = 0; i < length; i++) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength))
			}
			return result
		},
		localToUtcSameTime(localString) {
			const [datePart, timePart] = localString.split('T')
			const [year, month, day] = datePart.split('-').map(Number)
			const [hour, minute] = timePart.split(':').map(Number)

			// buat tanggal "UTC" langsung, tanpa konversi zona
			const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute))
			return utcDate.toISOString()
		},
		safeGet(obj, path, defaultValue = '-') {
			try {
				return path.split('.').reduce((acc, key) => acc && acc[key], obj) ?? defaultValue
			} catch (e) {
				return defaultValue
			}
		}
	}
}
